<template>
  <v-container class="top-pc">
    <!-- #LIVE -->
    <v-row justify="center" id="live">
      <v-col cols="7">
        <p class="top-pc__live--title-text">
          東京のど真ん中で、<span class="top-pc__live--under-line">日本初<div class="top-pc__live--title-text-attention">※</div>のサンゴ人工産卵</span>に挑戦中！
        </p>
        <p class="top-pc__live--youtube-attention">
          ※完全閉鎖系の人工環境下でのサンゴ産卵において
        </p>
      </v-col>
      <v-col cols="7">
        <iframe class="top-pc__live--youtube" src="https://www.youtube.com/embed/live_stream?channel=UCFvPsTDi0YlI8nDvdmglM_Q&autoplay=1" frameborder="0" allowfullscreen autoplay></iframe>
      </v-col>
      <v-col cols="7">
        <p class="top-pc__live--sub-title-text">
          <span class="top-pc__live--under-line">#サンゴ産卵の予感</span>を見つけたら、ボタンを押して教えてください！
        </p>
      </v-col>
      <v-col cols="7" class="text-center">
        <v-row>
          <v-col cols="6">
            <v-btn
              fab
              dark
              width="220px"
              height="220px"
              color="#E63946"
              @click="twitterShareDiscover"
            >
              <div class="top-pc__live--tweet-button">
                タマゴ
                <br>
                発見！
              </div>
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn
              fab
              dark
              width="220px"
              height="220px"
              color="#44C4BF"
              @click="twitterShareNotDiscover"
            >
              <div class="top-pc__live--tweet-button">
                タマゴ
                <br>
                未確認！
              </div>
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="top-pc__live--tweet-description">
          <v-col cols="6">
            <p>タマゴを発見できたらこちら！</p>
          </v-col>
          <v-col cols="6">
            <p>タマゴが見つからなかったらこちら！</p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <TopDescription/>

  </v-container>
</template>

<script>
import TopDescription from './TopDescription'

export default {
  name: 'Top',
  data: () => ({
  }),
  components: {
    TopDescription
  },
  methods: {
    twitterShareDiscover () {
      const url = `https://twitter.com/intent/tweet?text=%40Innoqua_inc%20%0A%E3%82%B5%E3%83%B3%E3%82%B4%E7%94%A3%E5%8D%B5%E3%81%AE%E4%BA%88%E6%84%9F%E3%82%92%E7%99%BA%E8%A6%8B%EF%BC%81%0A%E7%A2%BA%E8%AA%8D%E3%81%8A%E9%A1%98%E3%81%84%E3%81%97%E3%81%BE%E3%81%99!%0A%20%0Ahttps%3A%2F%2Fcoral.innoqua.jp%2F%20%0A%23%E3%82%B5%E3%83%B3%E3%82%B4%E7%94%A3%E5%8D%B5%E3%81%AE%E4%BA%88%E6%84%9F%20%0A%0A%E2%80%BB%E6%96%87%E7%AB%A0%E3%81%AF%E5%A4%89%E3%81%88%E3%81%9A%E3%81%AB%E3%83%84%E3%82%A4%E3%83%BC%E3%83%88%E3%81%97%E3%81%A6%E4%B8%8B%E3%81%95%E3%81%84`
      const option = 'status=1,width=400,height=400'
      window.open(url, 'twitter', option)
    },
    twitterShareNotDiscover () {
      const url = `https://twitter.com/intent/tweet?text=%E3%82%BF%E3%83%9E%E3%82%B4%E6%9C%AA%E7%A2%BA%E8%AA%8D%EF%BC%81%20%0A%23%E3%82%B5%E3%83%B3%E3%82%B4%E7%94%A3%E5%8D%B5%E3%81%AE%E4%BA%88%E6%84%9F%20%E3%83%81%E3%82%A7%E3%83%83%E3%82%AF%E4%B8%AD%E3%81%A7%E3%81%99%E3%80%82%0A%0A%E3%82%B5%E3%83%B3%E3%82%B4%E7%94%A3%E5%8D%B5%E3%81%AE%E4%BA%88%E6%84%9F%E3%82%92%E7%99%BA%E8%A6%8B%E3%81%99%E3%82%8B%E5%8D%94%E5%8A%9B%E8%80%85%E5%8B%9F%E9%9B%86%E4%B8%AD%EF%BC%81%0A%20https%3A%2F%2Fcoral.innoqua.jp%2F%20`
      const option = 'status=1,width=400,height=400'
      window.open(url, 'twitter', option)
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  margin: 0px;
  max-width: none;
}
.top-pc {
  background: $color-primary;
}
// PC LIVE
.top-pc__live--title-text {
  font-size: 1.8vw;
  font-weight: bold;
  letter-spacing: 3px;
  text-align: center;
  margin-top: 100px;
}
.top-pc__live--title-text-attention {
  display: inline;
  vertical-align: top;
  font-size: 1vw;
  font-weight: bold;
  letter-spacing: 3px;
  text-align: center;
}
.top-pc__live--under-line {
  border-bottom: solid;
  border-color: $color-accent;
  border-width: 5px;
  padding-bottom: 3px;
}
.top-pc__live--youtube {
  margin-top: 16px;
  border: solid;
  border-color: #F1FAEE;
  border-width: 5px;
  width: 100%;
  height: 450px;
}
.top-pc__live--youtube-attention {
  font-size: 1vw;
  text-align: right;
}
.top-pc__live--sub-title-text {
  font-size: 1.5vw;
  font-weight: bold;
  letter-spacing: 3px;
  text-align: center;
  margin-top: 24px;
}
.top-pc__live--tweet-button {
  font-size: 2vw;
  font-weight: 800;
  color: #F1FAEE;
}
.top-pc__live--tweet-description {
  font-size: 1.2vw;
  line-height: 2em;
  font-weight: bold;
}
.top-pc__live--tweet-attention {
  font-size: 0.8vw;
  line-height: 2em;
}
.top-pc__live--tweet-attention {
  line-height: 2em;
}
</style>
